module.exports = __webpack_public_path__ + "img/ec.01203bdb.svg";